export const SERIES_NCN = 'NCN';
export const SERIES_NCG = 'NCG';

export function isNcgSeries(seriesId?: string | null): boolean {
  return seriesId === SERIES_NCG;
}

export function toOfferId(seriesId: string, planId: string): string {
  return `${String(seriesId).toLowerCase()}:${String(planId).toLowerCase()}`;
}
